<template>
  <div>
    <Head title="កម្ចី" />
    <h1 class="moul flex items-center mb-8 text-2xl"><QueueListIcon class="mr-2 w-8 h-8" /> បញ្ជីបង់ប្រាក់</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <!-- <label class="block mt-4 text-gray-700">ស្ថានភាព:</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null">បង្ហាញតែកម្ចីមិនបានលុប</option>
          <option value="with">ជាមួយកម្ចីដែលបានលុប</option>
          <option value="only">បង្ហាញតែកម្ចីដែលបានលុប</option>
        </select> -->
      </search-filter>

      <Link class="btn-indigo flex items-center" href="/repays">
        <BanknotesIcon class="mr-1 w-4 h-4" />
        <span>បង់ប្រាក់</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">ID អតិថិជន</th>
          <th class="pb-4 pt-6 px-6">ឈ្មោះអ្នកខ្ចី</th>
          <th class="pb-4 pt-6 px-6">លេខសម្គាល់កម្ចី</th>
          <th class="pb-4 pt-6 px-6">កាលបរិច្ឆេទដែលបានបង់</th>
          <th class="pb-4 pt-6 px-6">ទឹកប្រាក់ដែលបានបង់</th>
          <th class="pb-4 pt-6 px-6"></th>
        </tr>
        <tr v-for="pay in pays.data" :key="pay.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/loans/${pay.loan_id}/schedule`" tabindex="-1">{{ pay.customer_id }} </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/loans/${pay.loan_id}/schedule`" tabindex="-1">{{ pay.borrower }} </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/loans/${pay.loan_id}/schedule`" tabindex="-1">
              {{ pay.loan_number_id }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/loans/${pay.loan_id}/schedule`" tabindex="-1">
              {{ formattedDate(pay.paid_date) }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/loans/${pay.loan_id}/schedule`" tabindex="-1">
              {{ formatNumber(pay.paid_amount) }}
            </Link>
          </td>

          <td class="w-px border-t">
            <Link class="flex items-center px-4" @click="destroy(pay.id)" tabindex="-1">
              <icon name="trash" class="block w-4 h-4 fill-red-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="pays.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="8">ពុំមានកម្ចីត្រូវបានបង្ហាញទេ!</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="pays.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import { QueueListIcon, BanknotesIcon } from '@heroicons/vue/24/outline'
import { formattedDate, formatNumber } from '@/helper'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
    QueueListIcon,
    BanknotesIcon,
  },
  layout: Layout,
  props: {
    filters: Object,
    pays: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
        gender: this.filters.gender,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/repay-lists', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    formatNumber,
    formattedDate,
    destroy(pay_id) {
      if (confirm('តើអ្នកពិតជាចង់លុបកម្ចីចេញមែនទេ?')) {
        this.$inertia.delete(`/repay-lists/${pay_id}`)
      }
    },
  },
}
</script>
